import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class UserFormatter extends Formatter {
}

// Пользователи панели (CRUD authorized/admin/users). Пароль сервер не возвращает.
export default class ApiUser extends ApiModelWithAuth {
    pathDef = 'authorized/admin/users';
    formatterItem = UserFormatter.Item;
}
